import React from 'react';
import ImageCarousel from './ImageCarousel';

const HeroSection = ({
  className = '',
  title,
  subtitle,
  paragraphs = [],
  bullets = [],
  badges = [],
  images = [],
  singleImage,
  onImageClick,
  inDevelopment = false,
}) => {
  return (
    <div className={`${className} app-section`}>
      {inDevelopment && (
        <div className="solution-dev-badge">Em Desenvolvimento</div>
      )}
      <div className={`${className}-content`}>
        {title && <h2>{title}</h2>}
        {subtitle && <h3>{subtitle}</h3>}
        {paragraphs?.map((text, i) => (
          <p key={i}>{text}</p>
        ))}
        {bullets?.length > 0 && (
          <ul>
            {bullets.map((b, i) => (
              <li key={i} dangerouslySetInnerHTML={{ __html: b }} />
            ))}
          </ul>
        )}
        {badges?.length > 0 && (
          <div className="hero-features">
            {badges.map((badge, i) => (
              <div className="feature-badge" key={i}>
                {badge.icon && <span className="feature-icon">{badge.icon}</span>}
                {badge.text}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="solution-hero-image">
        {singleImage ? (
          <img 
            src={singleImage} 
            alt={title || 'Imagem da solução'} 
            className="single-solution-image"
            onClick={() => onImageClick && onImageClick(singleImage)}
          />
        ) : (
          <ImageCarousel images={images} onImageClick={onImageClick} />
        )}
      </div>
    </div>
  );
};

export default HeroSection;


